import { SimplePaymentConfirmation } from './simple-payment-confirmation'

const DEPOSIT_STRINGS = {
  failedDescription:
    "Votre paiement d'acompte n'a pas pu être traité. Veuillez réessayer ou contacter votre banque si le problème persiste.",
  failedTitle: "Paiement de l'acompte échoué",
  successDescriptionBuilder: (amountLabel?: string, referenceLabel?: string) =>
    `Votre acompte${amountLabel ? ` de ${amountLabel}` : ''}${referenceLabel ?? ''} a bien été enregistré. Vous recevrez une confirmation par email sous peu.`,
  successTitle: 'Acompte reçu !',
  unknownDescription:
    "Nous n'avons pas pu confirmer l'état de votre paiement d'acompte. Vérifiez votre espace client ou contactez notre équipe si besoin.",
  unknownTitle: 'Statut de paiement indisponible',
} as const

interface DepositPaymentConfirmationProps {
  amountCents?: number
  reference?: string
  status: 'failed' | 'success' | 'unknown'
}

export function DepositPaymentConfirmation({
  amountCents,
  reference,
  status,
}: DepositPaymentConfirmationProps) {
  return (
    <SimplePaymentConfirmation
      amountCents={amountCents}
      reference={reference}
      retryLink="/payer-acompte"
      status={status}
      strings={DEPOSIT_STRINGS}
    />
  )
}
